<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">pan_tool</mat-icon>
        <span>
            Datenkollision erkannt
        </span>
        <span class="spacer"></span>
    </mat-toolbar>

    <div class="content">

        <div class="note-wrapper">

            <div class="note-hint">

                {{data.externalChange.user? data.externalChange.user: 'Ein Nutzer'}} hat das aktuelle Objekt ebenfalls verändert. Ihr Datenstand stimmt nicht mit dem Datenbestand des Servers überein.

            </div>

        </div>

        <ng-container #diffOuter></ng-container>

    </div>

    <div class="footer">

        <button mat-raised-button color="warn" (click)="close()">
            Meine Änderungen verwerfen
        </button>

    </div>

</div>